import React from 'react';

import Input from '../../../form/Input';
import InputFloat from '../../../form/InputFloat';
import Select from '../../../form/Select';
import Checkbox from '../../../form/Checkbox';
import SelectEmpresa from '../../../form/SelectEmpresa';

import formStyles from '../../../form/Form.module.css';

import maskCPForCNPJ from '../../../../utils/maskCPForCNPJ';
import maskCEP from '../../../../utils/maskCEP';

import { CRT_OPTIONS } from '../../../../constants/fiscal';

export default function TabCabecalho({ module, EnumTipo = [], EnumRamoAtividade = [], ufs = [], OptionsMatriz = [] }) {
    const { state, defaults, actions } = module;

    const { dados, preview, optionsMunicipios } = state;

    const { abertura, ultimaAtualizacao } = defaults;

    const { onFileChange, handleChange, handleOnBlur, handleOnFocus } = actions;

    return (
        <>
            <div className={formStyles.preview_logomarca}>
                <div>
                    <Input
                        text="Logomarca da Empresa"
                        type="file"
                        name="logomarca"
                        handleOnChange={onFileChange}
                        inputWidth="350px"
                        multiple
                    />
                </div>

                {preview.length > 0
                    ? preview.map((image, index) => (
                          <img
                              src={URL.createObjectURL(image)}
                              alt={dados?.nomeFantasia || dados?.razaoSocial || 'Logomarca'}
                              key={`${image.name}-${index}`}
                          />
                      ))
                    : dados?.logomarca && (
                          <img
                              src={`${process.env.REACT_APP_API}/imagens/${dados.logomarca}`}
                              alt={dados?.nomeFantasia || dados?.cnpj || 'Logomarca'}
                          />
                      )}
            </div>

            <div>
                <Input
                    text="CPF ou CNPJ"
                    type="text"
                    name="cnpj"
                    placeholder="CPF ou CNPJ da empresa"
                    title="Digite o CPF ou CNPJ da empresa. Ao sair do campo, caso seja um CNPJ, o sistema consultará os dados cadastrais."
                    minlength={14}
                    maxlength={18}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados?.cnpj ? maskCPForCNPJ(dados.cnpj) : ''}
                    required
                />

                <Input
                    text="RG ou IE"
                    type="text"
                    name="RGorIE"
                    placeholder="RG ou Inscrição Estadual"
                    title="Digite o RG ou a Inscrição Estadual"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados?.RGorIE ?? ''}
                />

                <Input
                    text="Razão Social"
                    type="text"
                    name="razaoSocial"
                    placeholder="Razão social da empresa"
                    title="Digite a razão social da empresa"
                    inputWidth="350px"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados?.razaoSocial ?? ''}
                    required
                />

                <Input
                    text="Nome Fantasia"
                    type="text"
                    name="nomeFantasia"
                    placeholder="Nome fantasia da empresa"
                    title="Digite o nome fantasia da empresa"
                    inputWidth="350px"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados?.nomeFantasia ?? ''}
                    required
                />
            </div>

            <div>
                <Input
                    text="Abertura"
                    type="date"
                    name="abertura"
                    placeholder="Abertura da empresa"
                    title="Data de abertura da empresa"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={abertura}
                />

                <Input
                    text="Última atualização"
                    type="datetime-local"
                    name="ultima_atualizacao"
                    placeholder="Última atualização"
                    title="Data da última atualização dos dados cadastrais"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={ultimaAtualizacao}
                />

                <Input
                    text="E-mail da Empresa"
                    type="email"
                    name="email"
                    placeholder="E-mail da empresa"
                    title="Digite o e-mail da empresa"
                    inputWidth="350px"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados?.email ?? ''}
                />
            </div>

            <div>
                <Select
                    name="ramoAtividade"
                    text="Selecione o ramo de atividade"
                    options={EnumRamoAtividade}
                    handleOnChange={handleChange}
                    value={dados?.ramoAtividade || 'Industria'}
                    isEnum
                />

                <Select
                    name="tipo"
                    text="Selecione Matriz ou Filial"
                    options={EnumTipo}
                    handleOnChange={handleChange}
                    value={dados?.tipo || 'MATRIZ'}
                    isEnum
                />

                <Checkbox
                    title="Quando marcado, informa que a empresa possui filial"
                    text="Possui Filial"
                    name="possuiFilial"
                    handleOnChange={handleChange}
                    value={dados?.possuiFilial}
                    checked={Boolean(dados?.possuiFilial)}
                />

                <SelectEmpresa
                    inputWidth="200px"
                    name="matriz"
                    text="Selecione Matriz"
                    options={OptionsMatriz}
                    handleOnChange={handleChange}
                    value={dados?.matriz || dados?.id || ''}
                    isEnum={false}
                />

                <SelectEmpresa
                    inputWidth="200px"
                    name="empresaPadraoId"
                    text="Empresa Padrão"
                    title="Alguns cadastros serão feitos na empresa padrão, utilizado quando existem várias empresas e há concentração de cadastro, em modulos automatizados"
                    options={OptionsMatriz}
                    handleOnChange={handleChange}
                    value={dados?.empresaPadraoId}
                    isEnum={false}
                />

                <Select
                    name="crt"
                    text="Regime Tributário (CRT)"
                    title="Selecione o regime tributário utilizado pela empresa"
                    options={CRT_OPTIONS}
                    handleOnChange={handleChange}
                    value={dados?.crt ?? ''}
                    isEnum={false}
                    notOptNull={false}
                    inputWidth="320px"
                    required
                />
            </div>

            <div>
                <Input
                    text="CEP"
                    type="text"
                    name="cep"
                    maxlength={10}
                    placeholder="CEP da empresa"
                    title="Digite o CEP da empresa"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados?.cep ? maskCEP(dados.cep) : ''}
                />

                <InputFloat
                    text="Latitude"
                    type="text"
                    name="latitude"
                    placeholder="Latitude da empresa"
                    title="Digite a latitude da localização da empresa"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados?.latitude ?? ''}
                    textAlign="right"
                />

                <InputFloat
                    text="Longitude"
                    type="text"
                    name="longitude"
                    placeholder="Longitude da empresa"
                    title="Digite a longitude da localização da empresa"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados?.longitude ?? ''}
                    textAlign="right"
                />
            </div>

            <div>
                <Select
                    text="Selecione o Estado"
                    name="ufId"
                    options={ufs}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados?.ufId ?? ''}
                    isEnum={false}
                />

                <Select
                    text="Município"
                    name="municipioId"
                    options={optionsMunicipios}
                    title="Escolha o município da empresa"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados?.municipioId ?? ''}
                    isEnum={false}
                />
            </div>

            <div>
                <Input
                    text="Bairro"
                    type="text"
                    name="bairro"
                    placeholder="Bairro da empresa"
                    title="Digite o bairro da empresa"
                    inputWidth="350px"
                    handleOnChange={handleChange}
                    value={dados?.bairro ?? ''}
                />

                <Input
                    text="Logradouro"
                    type="text"
                    name="logradouro"
                    placeholder="Logradouro da empresa"
                    title="Digite o logradouro da empresa"
                    inputWidth="350px"
                    handleOnChange={handleChange}
                    value={dados?.logradouro ?? ''}
                />

                <Input
                    text="Número"
                    type="text"
                    name="numero"
                    placeholder="Número da empresa"
                    title="Digite o número da empresa"
                    handleOnChange={handleChange}
                    value={dados?.numero ?? ''}
                />

                <Input
                    text="Complemento"
                    type="text"
                    name="complemento"
                    placeholder="Complemento da empresa"
                    title="Digite o complemento da empresa"
                    inputWidth="350px"
                    handleOnChange={handleChange}
                    value={dados?.complemento ?? ''}
                />
            </div>

            <div>
                <Input
                    text="Telefone"
                    type="text"
                    name="telefone"
                    placeholder="Telefone"
                    title="Telefone"
                    handleOnChange={handleChange}
                    value={dados?.telefone ?? ''}
                />

                <Checkbox
                    title="Usa o módulo de indústria"
                    text="Indústria"
                    name="isIndustria"
                    handleOnChange={handleChange}
                    value={dados?.isIndustria}
                    checked={Boolean(dados?.isIndustria)}
                />
            </div>
        </>
    );
}
